// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"206":"5e22fd23","512":"9c4e2130","711":"8e1d74a4"}[chunkId] || chunkId) + "." + {"55":"0377fcaeb63144a9","112":"8e3bfd27007c8002","206":"31bf9c6dc94b85ef","436":"a1db29f34bf629da","512":"a896cba7eab6477b","674":"c9ca300fe6f34b23","711":"595e775e33fe8e5f"}[chunkId] + ".js";
};